import searchDialog from './Main';
export default searchDialog;
